import { jsx as e } from "react/jsx-runtime";
import { useEffect as u } from "react";
import { I18nextProvider as p } from "react-i18next";
import { I18nService as a } from "@perxis-auto/shared";
import { Provider as d } from "@perxis-auto/ui-kit/lib/components/Provider";
import { AppProvider as c } from "./providers/AppProvider/AppProvider.js";
import f from "../shared/assets/locales/en/translation.json.js";
import s from "../shared/assets/locales/ru/translation.json.js";
import l from "../shared/assets/locales/uz/translation.json.js";
import { APP as o } from "../shared/config/app.js";
import { APP_EVENTS as v } from "../shared/config/events.js";
import { useAppContext as P, CurrencyEnum as E, LanguageEnum as r } from "../shared/lib/app/context/appContext.js";
import { eventService as R } from "../shared/lib/event/eventService.js";
import { Form as g } from "../widgets/Form/ui/Form.js";
import "../shared/assets/styles/main.scss.js";
/* empty css         */
const A = (t) => {
  const { language: n = r.Ru, currency: m = E.RUB } = P();
  u(() => {
    R.sendEvent(v.Initialized);
  }, []);
  const i = a.getInstance({ language: n, currency: m }).i18n.addResourceBundle(r.En, o.name, f, !0, !0).addResourceBundle(r.Ru, o.name, s, !0, !0).addResourceBundle(r.Uz, o.name, l, !0, !0);
  return /* @__PURE__ */ e(d, { children: /* @__PURE__ */ e(p, { i18n: i, children: /* @__PURE__ */ e(g, { ...t }) }) });
};
A.Provider = c;
export {
  A as App
};
